import * as types from "../types/smsBalance"
import { getSMSBalance } from "services"

export const fetchSmsBalance = (branchId) => (
  async (dispatch) => {
    try {
      const { balance } = await getSMSBalance(branchId)

      dispatch({
        type: types.FETCH_SMS_BALANCE,
        smsBalance: balance
      })
    } catch (err) {
      console.log(err)
    }
  }
)

export const updateSmsBalance = (smsBalance) => ({
  type: types.UPDATE_SMS_BALANCE,
  smsBalance
})

export const clearSmsBalance = () => ({
  type: types.CLEAR_SMS_BALANCE
})